<template>
  <div class="content">
    <el-row :gutter="20">
      <!--代理商数据-->
      <el-col :span="5" :xs="24">
        <div class="head-container">
          <el-input
            v-model="agentName"
            placeholder="请输入公司名称"
            clearable
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree
            class="agent-tree"
            :data="agentList"
            :props="agentProps"
            node-key="userId"
            :expand-on-click-node="true"
            :filter-node-method="agentFilterNode"
             ref="tree"
            :default-expand-all="expandNode"
            :highlight-current="true"
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--费率数据-->
      <el-col :span="19" :xs="24">
          <el-form :model="queryParams" ref="queryParams" :inline="true">
            <el-form-item prop="rate">
              <el-select v-model="queryParams.rate" filterable  clearable placeholder="是否设置费率">
                <el-option v-for="item in status" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="level">
              <el-select v-model="queryParams.level" filterable  clearable placeholder="代理商层级">
                <el-option v-for="item in levels" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
              <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="handleCreate" >批量设置费率</el-button>
            </el-form-item>
          </el-form>
          <div class="table">
            <el-table :data="tableData" border >
              <el-table-column prop="company" label="公司名称" align="center" min-width="200" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  [{{scope.row.username}}]{{scope.row.company}}
                </template>
              </el-table-column>
              <el-table-column prop="level" label="公司层级" align="center">
                <template slot-scope="scope">
                  {{scope.row.level}}级
                </template>
              </el-table-column>
              <el-table-column prop="rate" label="设置费率" align="center" >
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.rate=='1'">是</el-tag>
                  <el-tag type="danger" v-else>否</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="taxRate" label="税率%" align="center" ></el-table-column>
              <el-table-column prop="wxServiceRate" label="微信手续费%" align="center" min-width="120"></el-table-column>
              <el-table-column prop="alipayServiceRate" label="支付宝手续费%" align="center" min-width="120"></el-table-column>
              <el-table-column prop="bankServiceRate" label="银行卡手续费%" align="center" min-width="120"></el-table-column>
              <el-table-column prop="balanceServiceRate" label="余额手续费%" align="center" min-width="120"></el-table-column>
              <el-table-column prop="extraPriceRate" label="套餐加价续费%" align="center" min-width="120"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
              <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="handleEdit(scope.row)" >编辑</el-button>
                  <el-button size="mini" type="danger"  plain icon="el-icon-delete" @click="deleteRate(scope.row)" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 20, 30, 40]"
              @size-change="handleSizeChange"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
      </el-col>
    </el-row>
    <!--批量设置费率  -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" :inline="true">
          <el-form-item label="公司选择" prop="userIds">
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText">
              </el-input>
              <el-checkbox v-model="agentNodeAll" @change="handleCheckedTreeNodeAll($event, 'agent')">全选/全不选</el-checkbox>
              <div class="down-tree">
                  <el-tree
                    class="tree-border"
                    :data="agentList"
                    show-checkbox
                    ref="agent"
                    node-key="userId"
                    :check-strictly="!form.userCheckStrictly"
                    empty-text="加载中，请稍候"
                    :props="defaultProps"
                    :filter-node-method="filterNode"
                  ></el-tree>
              </div>
          </el-form-item>
          <el-form-item  label="税率" prop="taxRate">
            <el-input placeholder="税率" v-model="form.taxRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="微信手续费率" prop="wxServiceRate" >
            <el-input placeholder="微信手续费率" v-model="form.wxServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="支付宝手续费率" prop="alipayServiceRate" >
            <el-input placeholder="支付宝手续费率" v-model="form.alipayServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="银行卡手续费率" prop="bankServiceRate" >
            <el-input placeholder="银行卡手续费率" v-model="form.bankServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="余额手续费率" prop="balanceServiceRate" >
            <el-input placeholder="余额手续费率" v-model="form.balanceServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="套餐加价费率" prop="extraPriceRate" >
            <el-input placeholder="套餐加价费率" v-model="form.extraPriceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--修改代理商费率  -->
    <el-dialog :title="editTitle" :visible.sync="editOpen" width="500px" append-to-body>
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="120px">
          <el-form-item  label="代理商名称">
            <el-input  v-model="editForm.company" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  label="税率" prop="taxRate">
            <el-input placeholder="税率" v-model="editForm.taxRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="微信手续费率" prop="wxServiceRate" >
            <el-input placeholder="微信手续费率" v-model="editForm.wxServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="支付宝手续费率" prop="alipayServiceRate" >
            <el-input placeholder="支付宝手续费率" v-model="editForm.alipayServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="银行卡手续费率" prop="bankServiceRate" >
            <el-input placeholder="银行卡手续费率" v-model="editForm.bankServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="余额手续费率" prop="balanceServiceRate" >
            <el-input placeholder="余额手续费率" v-model="editForm.balanceServiceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item  label="套餐加价费率" prop="extraPriceRate" >
            <el-input placeholder="套餐加价费率" v-model="editForm.extraPriceRate" type="text" oninput="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">%</template>
            </el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmit">确 定</el-button>
        <el-button @click="cancelEdit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentTreeList,withdrawalRatePage,saveOrUpdateRate ,updateProductFree} from "@/api/api.js";
export default {
  name: "rateList",
  data() {
    var checkRate = (rule, value, callback) => {
        if (!value && value !='0') {
          return callback(new Error('输入框不能为空'));
        }else{
          value = String(value);
          if(value.indexOf(".") != -1 && value.split('.').length > 2){
              callback(new Error('请输入正确格式的数字'));
            }else if(value.indexOf(".") != -1 && value.split('.')[1].length > 2){
              callback(new Error('请输入正确的小数位数'));
            }else{
              callback(); 
            }
          
        }
      };
      var checkUsers = (rule, value, callback) => {
        let userIds = this.getAgentAllCheckedKeys();
        if(userIds.length==0){
          callback(new Error('请选择公司'));
        }else{
          callback(); 
        }
      };
    return {
      // 查询条件
      agentList:[],
      expandNode:false,
      queryParams: {
        userId:undefined
      },
      status:[
        {key:"1",value:"是"},
        {key:"0",value:"否"}
      ],
      levels:[
        {key:"1",value:"一级"},
        {key:"2",value:"二级"},
        {key:"3",value:"三级"},
        {key:"4",value:"四级"},
        {key:"5",value:"五级"},
        {key:"6",value:"六级"},
      ],
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      title:"",
      // 是否显示弹出层
      open: false,
      filterText:'',
      // 表单参数
      form: {
        taxRate:"0",
        wxServiceRate:"0",
        wxServiceRate:"0",
        alipayServiceRate:"0",
        bankServiceRate:"0",
        balanceServiceRate:"0",
        extraPriceRate:"0",
        userCheckStrictly:true,
        userIds: [],
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      agentName:'',
      agentProps:{
        children: "children",
        label: "label"
      },
      agentNodeAll: false,
      rules: {
          taxRate:[{ validator: checkRate, trigger: 'blur' }],
          wxServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          alipayServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          bankServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          balanceServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          extraPriceRate:[{ validator: checkRate, trigger: 'blur' }],
          userIds:[{validator: checkUsers, trigger: 'blur'}]
      },
      editTitle:"修改费率",
      editOpen:false,
      editForm:{
        userId:'',
        company:undefined,
        taxRate:"0",
        wxServiceRate:"0",
        wxServiceRate:"0",
        alipayServiceRate:"0",
        bankServiceRate:"0",
        balanceServiceRate:"0",
        extraPriceRate:"0",
        userIds:[]
      },
      editRules: {
          taxRate:[{ validator: checkRate, trigger: 'blur' }],
          wxServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          alipayServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          bankServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          balanceServiceRate:[{ validator: checkRate, trigger: 'blur' }],
          extraPriceRate:[{ validator: checkRate, trigger: 'blur' }],
      },

    };
  },
  watch: {
      agentName(val) {
        this.$refs.tree.filter(val);
      },
      filterText(val) {
        this.$refs.agent.filter(val);
      }
    },
  computed: {},
  methods: {
    // 搜索
    search() {
      this.page = 1,
      this.tabeInit();
    },
    //代理商层级
    agentTree(){
      agentTreeList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 获取列表
    tabeInit() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      withdrawalRatePage(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.tabeInit();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.tabeInit();
    },
    //表单重置
    reset(){
      if (this.$refs.agent != undefined) {
        this.$refs.agent.setCheckedKeys([]);
      }
      this.resetForm("form");
    },

    // 添加
    handleCreate() {
      this.reset();
      this.title = "代理商配置费率";
      this.open = true;
    },
    // 编辑
    handleEdit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editOpen = true;
    },
    //移除
    deleteRate(row){
      this.$confirm('是否确认将【'+row.company+'】的赠送套餐移除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            
        })
    },
    // 重置
    resetQuery() {
      this.agentName = '';
      this.treeExpand(false);
      this.queryParams.userId = undefined;
      this.resetForm("queryParams");
      this.tabeInit();
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.tabeInit();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.search();
    },
    treeExpand(flag){
        let treeList = this.agentList;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.tree.store.nodesMap[treeList[i].userId].expanded = flag;
        }
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.userId = data.userId;
      this.tabeInit();
    },
    agentFilterNode(value, data, node){
      if (!value) return true
      let if_one = data.label.indexOf(value) !== -1
      let if_two = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let if_three = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let result_one = false
      let result_two = false
      let result_three = false
      if(node.level === 1) {
        result_one = if_one
      }else if(node.level === 2) {
        result_two = if_one || if_two
      }else if(node.level === 3) {
        result_three = if_one || if_two || if_three
      }
      return result_one || result_two || result_three
      //return node.data.label.indexOf(value) !== -1 || (node.parent.data.label && node.parent.data.label.indexOf(value) !== -1)
      // return data.label.indexOf(value) !== -1;
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      this.$refs.agent.setCheckedNodes(value ? this.agentList: []);
    },
    // 所有代理商节点数据
    getAgentAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.agent.getCheckedKeys();
      return checkedKeys;
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.userIds = this.getAgentAllCheckedKeys();
          saveOrUpdateRate(this.form).then(response => {
            this.$message.success("修改代理商费率成功");
            this.editOpen = false;
            this.search();
          });
        }
      });
    },
    editSubmit(){
        let userId = this.editForm.userId;
        this.editForm.userIds = [userId];
        this.$refs["editForm"].validate(valid => {
          if (valid) {
            saveOrUpdateRate(this.editForm).then(res => {
              this.$message.success("设置代理商费率成功");
              this.editOpen = false;
              this.search();
            });
          }
        });
    },
    cancelEdit(){
      this.editOpen = false;
      this.search();
    }
  },
  mounted() {
  },
  created() {
    this.agentTree();
    this.tabeInit();
  }
};
</script>
<style scoped lang="less">

.down-tree{
    margin-bottom: 10px;
    height: 300px;
    display: block;
    overflow-y: scroll;

}
@media (min-width: 1156px) {
  .agent-tree{
    height: 700px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}
@media screen and (min-width: 768px) and (max-width: 1156px){
				
	.agent-tree{
    height: 500px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}

</style>